export default "__VITE_ASSET__CeSiQrIN__"